module.exports = __webpack_public_path__ + "img/Group 28015@2x.9920d126.png";